import { AxiosResponse } from 'axios';
import { DataRackSearchResultListResponse, SearchResultResponse } from 'types/entity';

import { http } from './settings';

export const fetchSearchResultGadgetDetail = (
  projectId: string,
  searchCriteriaId: string,
): Promise<{ [searchCriteriaId: string]: SearchResultResponse[] }> => http.get(`/projects/${projectId}/search-criterias/${searchCriteriaId}/search`)
  .then((value: AxiosResponse<DataRackSearchResultListResponse>) => ({ [searchCriteriaId || '']: value.data.search_results || [] }));
